import { createMemoryHistory } from 'history';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';

export class RouterModel extends RouterStore {
  constructor() {
    super();
    if (process.env.SERVER) {
      const memoryHistory = createMemoryHistory();
      syncHistoryWithStore(memoryHistory, this);
    }
  }
}
